module.exports = __webpack_public_path__ + "static/media/fakeGoogleMaps.d1aedf9d.png";